<template>
    <div class="grid">
    <div class="col-12">
        <Card id="toolbar">
            <template #title>
                <Toolbar>
                    <template #right>
                        <div class="p-card-title" style="margin-top:10px;">
                            <Button label="Print" icon="pi pi-print pi-fw" class="p-button-success mr-2" @click="downloadPrint()" />
                            <Button v-if="this.$IS_PRINT_DOCUMENT == 'TRUE'" label="Pdf" icon="pi pi-file-pdf pi-fw" class="p-button-danger mr-2" @click="exportToPDF" />
                            <Button label="Back" icon="pi pi-chevron-left" class="p-button-primary"  @click="backToIndex" />
                        </div>
                    </template>
                </Toolbar>
            </template>
        </Card>
        <div class="surface-0">
            <div id="apps" class="center">
                <table id="table" class="table" ref="document" style="font-family:'Times New Roman', Times, serif;font-size:12px;" v-if="dataDocument">
                   <thead id="thead">
                        <tr style="text-align:center;">
                            <!-- <td colspan="1" rowspan="2">
                                <img src="/assets/layout/images/wilmar-logo.png"  style="float:left;" width="120" height="40"/>
                            </td> -->
                            <td colspan="4"  rowspan="2" style="color:#8e8158e4;font-size:13px;font-weight:bold;">
                                PROJECT QUALITY CONTROL
                            </td>
                            <td colspan="3" rowspan="3" style="color:#8e8158e4;font-size:15px;font-weight:bold;">
                                <i>FINAL INSPECTION REPORT</i>
                            </td>
                            <td colspan="3">R.4</td>
                            <!-- <td colspan="2" style="width:10%;">
                               <div class="page-number"></div>
                            </td> -->
                        </tr>
                        <tr style="text-align:center;"> 
                            <td colspan="3" rowspan="2">Work Handover Obligatory Document <i>(issued only by QC)</i></td>
                        </tr>
                        <tr style="text-align:center;">
                            <td colspan="2">UNIT : {{ dataDocument.location }}</td>
                            <td colspan="2">{{"QC-FRM-GEN-C2" /*dataDocument.Doc_No*/}}</td>
                        </tr>
                        <tr style="height:15px;">
                            <td style="border:none;"></td>
                            <td style="border:none;"></td>
                            <td style="border:none;"></td>
                            <td style="border:none;"></td>
                            <td style="border:none;"></td>
                            <td style="width:10%;border:none;"></td>
                            <td style="width:10%;border:none;"></td>
                            <td style="border:none;"></td>
                            <td style="border:none;"></td>
                            <td style="border:none;"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="10" style="background-color:rgb(200, 200, 200);">
                                <i>Inspection Details</i>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:10%;">Date / Time</td>
                            <td colspan="3">{{this.$formatDate(dataDocument.Date_Time)}}</td>
                            <td colspan="2">SPK Number</td>
                            <td colspan="4">{{dataDocument.No_SPK != null ? dataDocument.No_SPK : "-"}}</td>
                        </tr>
                        <tr>
                            <td>Contractor</td>
                            <td colspan="3">{{dataDocument.contractor}}</td>
                            <td colspan="2">SPO Number</td>
                            <td colspan="4">{{dataDocument.No_SPO != null ? dataDocument.No_SPO : "-"}}</td>
                        </tr>
                        <tr>
                            <td>Area / Plant</td>
                            <td colspan="3">{{dataDocument.Area_Plant}}</td>
                            <td colspan="2">Report Number</td>
                            <td colspan="4">{{dataDocument.Report_Number}}</td>
                        </tr>
                        <tr>
                            <td>Scope</td>
                            <td colspan="3">{{dataDocument.Scope}}</td>
                            <td colspan="2">Inspector</td>
                            <td colspan="4">{{dataDocument.inspector}}</td>
                        </tr>
                        <tr style="height:50px;">
                            <td>
                                Contract Title
                            </td>
                            <td colspan="9"><p> {{dataDocument.Contractor_Title}}</p></td>
                        </tr>
                        <tr>
                            <td colspan="10" style="background-color:rgb(200, 200, 200);">
                                <i>Participants :</i>
                            </td>
                        </tr>
                        <tr style="text-align:center;font-weight:bold;">
                            <td>S/N</td>
                            <td colspan="3">NAME</td>
                            <td>POSITION</td>
                            <td colspan="5">COMPANY</td>
                        </tr>
                        <tr v-for="(item, i) in dataDocument.Participants" :key="item.Id" style="text-align:center;">
                            <td>{{i+1}}</td>
                            <td colspan="3">{{item.Name}}</td>
                            <td>{{item.Position}}</td>
                            <td colspan="5">{{item.Company}}</td>
                        </tr>
                        <tr>
                            <td colspan="10" style="background-color:rgb(200, 200, 200);">
                                <i>Result : </i>
                            </td>
                        </tr>
                        <tr style="text-align:center;">
                            <td>
                                <span v-if="dataDocument.Accept_Repair == 'ACCEPTED'">&#10004;</span>
                            </td>
                            <td colspan="2" style="width:15%;">Accepted</td>
                            <td style="width:15%;"><span v-if="dataDocument.Accept_Repair == 'REPAIR'">&#10004;</span></td>
                            <td style="color:red;">Repair *</td>
                            <td colspan="5">FINAL INSPECTION #</td>
                        </tr>
                        <tr style="height:20px;">
                            <td colspan="10">
                               <p align="justify">* All found items stated below will be rectified within {{dataDocument.Days }} day (s).<br/>
                                &nbsp;&nbsp;&nbsp;Next Inspection (s) should be submitted until all items have been rectified properly. </p> 
                            </td>
                        </tr>
                        <tr style="height:50px;">
                            <td>
                                Comments:
                            </td>
                            <td colspan="9"><p>{{dataDocument.Comments}}</p></td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="5" style="text-align:center;background-color:rgb(200, 200, 200);">Prepared by</td>
                            <td colspan="5" style="text-align:center;background-color:rgb(200, 200, 200);">Approved by</td>
                        </tr>
                        <tr style="text-align:center;height:30px;">
                            <td style="text-align:left;">Party</td>
                            <td colspan="1">PROJECT QUALITY CONTROL CIVIL</td>
                            <td colspan="2">PROJECT QUALITY CONTROL MECHANICAL</td>
                            <td colspan="1">PROJECT QUALITY CONTROL ELECTRICAL</td>
                            <td style="text-align:left;">Party</td>
                            <td colspan="4">{{ dataDocument.Appr_As1 }}</td>
                        </tr>
                        <tr style="text-align:center;">
                            <td style="text-align:left;" rowspan="2">Name</td>
                            <td colspan="1" rowspan="2" :class="{'backgorund' : dataDocument.qc_sipil == this.$DOCUMENT_STATUS.NO_NEED_APPROVAL}">{{dataDocument.qc_sipil != this.$DOCUMENT_STATUS.NO_NEED_APPROVAL? dataDocument.sign_qc_sipil : ""}}</td>
                            <td colspan="2" rowspan="2" :class="{'backgorund' : dataDocument.qc_mekanikal == this.$DOCUMENT_STATUS.NO_NEED_APPROVAL}">{{dataDocument.qc_mekanikal != this.$DOCUMENT_STATUS.NO_NEED_APPROVAL? dataDocument.sign_qc_mekanikal : ""}}</td>
                            <td colspan="1" rowspan="2" :class="{'backgorund' : dataDocument.qc_electrical == this.$DOCUMENT_STATUS.NO_NEED_APPROVAL}">{{dataDocument.qc_electrical != this.$DOCUMENT_STATUS.NO_NEED_APPROVAL? dataDocument.sign_qc_electrical : ""}}</td>
                            <td style="text-align:left;">Name</td>
                            <td colspan="4" :class="{'backgorund' : dataDocument.qc_name == this.$DOCUMENT_STATUS.NO_NEED_APPROVAL}">{{dataDocument.qc_name != this.$DOCUMENT_STATUS.NO_NEED_APPROVAL? dataDocument.Appr_Name1 : ""}}</td>
                        </tr>
                        <tr style="text-align:center;height:30px;">
                            <!-- <td style="text-align:left;">Sign</td> -->
                            <!--<td colspan="1" :class="{'backgorund' : dataDocument.qc_sipil == this.$DOCUMENT_STATUS.NO_NEED_APPROVAL}">
                                 <p v-if="dataDocument.sign_qc_sipil!=null" class="fontsign">
                                    {{ dataDocument.sign_qc_sipil }}
                                </p> 
                            </td>
                            <td colspan="2" :class="{'backgorund' : dataDocument.qc_mekanikal == this.$DOCUMENT_STATUS.NO_NEED_APPROVAL}">
                                <p v-if="dataDocument.sign_qc_mekanikal!=null" class="fontsign">
                                    {{ dataDocument.sign_qc_mekanikal }}
                                </p>
                            </td>
                            <td colspan="1" :class="{'backgorund' : dataDocument.qc_electrical == this.$DOCUMENT_STATUS.NO_NEED_APPROVAL}">
                                 <p v-if="dataDocument.sign_qc_electrical!=null" class="fontsign">
                                    {{ dataDocument.sign_qc_electrical }}
                                </p>
                            </td>-->
                            <td style="text-align:left;">Sign</td>
                            <td colspan="5" :class="{'backgorund' : dataDocument.qc_name == this.$DOCUMENT_STATUS.NO_NEED_APPROVAL}">
                                <p v-if="dataDocument.Appr_Name1" class="fontsign">
                                    {{ dataDocument.Appr_Name1 }}
                                </p>
                            </td>
                        </tr>
                        <tr style="text-align:center;">
                            <td style="text-align:left;">Date</td>
                            <td colspan="1" :class="{'backgorund' : dataDocument.qc_sipil == this.$DOCUMENT_STATUS.NO_NEED_APPROVAL}">{{this.$formatDateTime3(dataDocument.qc_sipil_approved_date)}}</td>
                            <td colspan="2" :class="{'backgorund' : dataDocument.qc_mekanikal == this.$DOCUMENT_STATUS.NO_NEED_APPROVAL}">{{this.$formatDateTime3(dataDocument.qc_mekanikal_approved_date)}}</td>
                            <td colspan="1" :class="{'backgorund' : dataDocument.qc_electrical == this.$DOCUMENT_STATUS.NO_NEED_APPROVAL}">{{this.$formatDateTime3(dataDocument.qc_electrical_approved_date)}}</td>
                            <td style="text-align:left;">Date</td>
                            <td colspan="4" :class="{'backgorund' : dataDocument.qc_name == this.$DOCUMENT_STATUS.NO_NEED_APPROVAL}">{{this.$formatDateTime1(dataDocument.ApprDate1)}}</td>
                        </tr>
                        
                        <tr>
                            <td colspan="10" style="background-color:rgb(200, 200, 200);">
                                <i>Inspection Photos :</i>
                            </td>
                        </tr>
                        <tr v-for="(item, i) in dataDocument.Inspections" :key="item.Id"  
                        :class="{'pagebreak' : (arrindex1.length >=10 &&  (i) == 0) || (arrindex.includes(i+1)) || (arrindex1.length <10 && (i +1) == 2) }">
                            <td colspan="10">
                                <table style="width:100%; border-collapse: collapse;">
                                    <tr style="text-align:center;">
                                        <td style="border-top:none; border-left:none;"># </td>
                                        <td colspan="3" style="border-top:none; border-left:none;">{{"INSPECTION # " }} {{ item.Inspection_Currently}}</td>
                                        <td colspan="3" style="border-top:none; border-left:none;">{{"INSPECTION # "}} {{item.Inspection_Previosly}}</td>
                                        <td colspan="3" rowspan="2" style="border-top:none; border-left:none;border-right: none;">REMARKS</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align:center;border-left:none;">Date</td>
                                        <td colspan="3">Currently:</td>
                                        <td colspan="3">Previously:</td>
                            
                                    </tr>
                                    <tr>
                                        <td rowspan="10" style="border-left: none;border-bottom:none;">{{this.$formatDate(item.Date)}}</td>   
                                        <td rowspan="10" colspan="3" style="border-bottom:none;text-align:center;">
                                            <img :src="item.Currently" width="200" height="100"/>
                                        </td>
                                        <td rowspan="10" colspan="3" style="border-bottom:none;text-align:center;">
                                            <img :src="item.Previously" width="200" height="100"/>
                                        </td>
                                        <td colspan="2">Result</td>
                                        <td style="width: 20%;border-right: none;">{{item.Result}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">Issue</td>
                                        <td style="width: 20%;border-right: none;">{{item.Issue}}</td>
                                    </tr>
                                    
                                    <tr>
                                        <td colspan="2">Scope</td>
                                        <td style="width: 20%;border-right: none;">{{item.Scope}}</td>
                                    </tr>


                                    <tr>
                                        <td colspan="2">Item</td>
                                        <td style="width: 20%;border-right: none;">{{item.Identitas}}</td>
                                    </tr>
                                    <tr style="height:15px;">
                                        
                                        
                                        <td colspan="3" style="border-right: none;"></td>
                                    </tr>
                                    <tr style="height:15px;">
                                        
                                        
                                        <td colspan="2">Rectification</td>
                                        <td style="width: 20%;border-right: none;">{{item.Rectification}}</td>
                                    </tr>
                                    <tr style="height:15px;">
                                        
                                        
                                        <td colspan="3" style="border-right: none;"></td>
                                    </tr>
                                    <tr style="height:15px;">
                                        
                                        
                                        <td colspan="3" style="border-right: none;"></td>
                                    </tr>
                                    <tr style="height:15px;">
                                        
                                        
                                        <td colspan="3" style="border-right: none;"></td>
                                    </tr>
                                    <tr style="height:15px;">
                                        
                                    
                                        <td colspan="3" style="border-right: none;border-bottom:none;"></td>
                                        
                                    </tr>
                                
                                </table>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot id="footer">
                        <tr>
                            <td colspan="5" style="border: none;" class="tdfoot">
                                <img src="/assets/layout/images/stamp-draft.png" height="120" width="140" v-if="dataDocument.Status == this.$REQUEST_STATUS.DRAFT|| dataDocument.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || dataDocument.Status == this.$APPROVAL_STATUS.REVISED"/>
                            </td>
                            <td colspan="5" style="border: none;" class="tdfoot">
                                <VueQrcode :value="valueLink" style="width:85px;float:right;" id="qr"></VueQrcode>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="10" style="border: none;" v-if="dataDocument.is_aproved">
                                <p style="font-size:10px;">
                                    <b>
                                        {{ 
                                            this.signBy(dataDocument)
                                        
                                        }}

                                    </b>
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 30px;" v-if="dataDocument.is_aproved">
                            <td style="border: none;"></td>
                        </tr>
                        <tr style="height: 20px;" v-else>
                            <td style="border: none;"></td>
                        </tr>
                    </tfoot>
                </table>
            </div> 
        </div>
</div>
</div>

</template>


<script>
import html2pdf from 'html2pdf.js'

export default{
data(){
    return {
        listDoc : null,
        dataheader : null,
        title : "listdocuments",
        docvalidity : [],
        type :this.$TypeDocument.BA_IK_WITH_SPO,
        compCode : "",
        dataDocument:null,
        imgdocumentation : "",
        companydetail : null,
        is_receive :false,
        is_not_receive : false,
        valueLink :this.$store.getters.getUrlApp + this.$route.fullPath,
        arrindex : [],
        arrindex1 : []
    }
},
methods:{
    signBy(data){
        this.signby = `${this.$DOCUMENTFOOTER.APPROVED_GENERATED} (Document Print by ${this.$store.getters.getFullname} at ${this.$formatDateTime2(new Date())})`; 
        return this.signby;
    },  
    backToIndex(){
        if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
        else 
            this.$router.push({ path: "/QcFinal/Index" });
    },
    downloadPrint(){
        this.$emit('block-ui');
            var self = this;
                const link = this.valueLink;
                //var qr = document.getElementById('qr').src;
                //const [mimeType, base64Data] = dataURL.split(';base64,');
                this.$axios.get(this.$API_URL + "QcFinal/" + "exportprint", {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG,
                params : {
                    id : this.$route.query.id,
                    linqr : link,
                    company : this.dataDocument.company,
                    contractor : this.dataDocument.contractor,
                    signby : this.signby,
                }  
                })
                .then((response) => {
                    //const url = window.URL.createObjectURL(new Blob([response.data]));
                    let fileName = response.headers["content-disposition"].split("filename=")[1].split(";")[0];

                    const blob = new Blob([response.data], { type: 'application/pdf' });

                    // Create an object URL from the Blob
                    const url = URL.createObjectURL(blob);
                    // Set the iframe src attribute to the object URL
                    window.open(url, '_blank');
                    //this.$refs.pdfPreview.src = url;
                    // const link = document.createElement('a');
                    // link.href = url;
                    // link.setAttribute('download', fileName);
                    // document.body.appendChild(link);
                    // link.click();
                    self.$emit('unblock-ui');
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    self.$emit('unblock-ui');
                    //self.showAssignModal = false;
                });
    },
    printWindow() {
        this.addPagenumber();
        window.print();
        this.removePageNumbers();
    },
    addPagenumber(){
        let pageNumber = 1;
        var table = this.$refs.document;
        var scrollHeight = table.offsetHeight;
        var totalPages = Math.round(scrollHeight / window.outerHeight);
   
        for (let i = 0; i < totalPages; i++) {
            var pageNumberDiv = document.createElement("div");
            var pgNum = document.createTextNode("" + (i+1) + "/" + totalPages);
            pageNumberDiv.classList.add('page-number');
            pageNumberDiv.style.position = "absolute";

            if(i != 0){
                pageNumberDiv.style.top = "calc((279mm - (0.5px + " +(i+1)+ "px)) * " + (i+1)+ " - 40px)";
            }else{
                pageNumberDiv.style.top = "calc((279mm - 0.5px) * " + (i+1)+ " - 40px)";
            }
           
            pageNumberDiv.style.right = 0;
            pageNumberDiv.style.height = "12px";
            pageNumberDiv.appendChild(pgNum);
            document.body.appendChild(pageNumberDiv);
            
        }
    },
    removePageNumbers() {
        const pageNumberElements = document.querySelectorAll('.page-number');
        pageNumberElements.forEach(element => element.remove());
    },

    exportToPDF() {
        
        var table = document.getElementById('apps');
        var scrollHeight = table.scrollHeight;
        var totalPages = Math.floor(scrollHeight / window.innerHeight);
        document.querySelectorAll('.page-number')[0].textContent = 'Page ' + 1 + ' of ' + totalPages;
        
        html2pdf(this.$refs.document, {
            margin: 10,
            filename: 'myfile.pdf',
            image: { type: 'jpeg', quality: 1},
            html2canvas: { scale: 4},
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },

        })

        // jsPDF.autoTable = jsPDFAutoTable;
        // var doc = new jsPDF("p","pt","a4");
        // window.html2canvas = html2canvas;
        // let pWidth = doc.internal.pageSize.width; // 595.28 is the width of a4
        // let srcWidth = this.$refs.document.scrollWidth;
        // let margin = 25; // narrow margin - 1.27 cm (36);
        // let scale = (pWidth - margin * 2) / srcWidth;
        // doc.html(this.$refs.document, {
        //     x: margin,
        //     y: margin,
        //     html2canvas: {
        //         scale: scale,
        //     },
        //     callback: function () {
        //         // doc.setFontSize(12);
        //         // const pageCount = doc.internal.getNumberOfPages();
        //         // for(let i = 1; i <= pageCount; i++) {
        //         //     doc.setPage(i);
        //         //     const pageSize = doc.internal.pageSize;
        //         //     const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
        //         //     const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        //         //     const header = 'Report 2014';
        //         //     const footer = `Page ${i} of ${pageCount}`;

        //         //     // Header
        //         //     doc.text(header, 40, 15, { baseline: 'top' });

        //         //     // Footer
        //         //     doc.text(footer, pageWidth / 2 - (doc.getTextWidth(footer) / 2), pageHeight - 15, { baseline: 'bottom' });
        //         // }
        //         window.open(doc.output('bloburl'));
        //     }
        // });

        
    },
    getData() {
            this.$emit('block-ui');
            let self = this;
            self.$axios.get(this.$API_URL + "QcFinal/getDataDoc/"+ this.$route.query.id 
            ).then((response) => {
                var data = response.data.data;
                self.dataDocument = data.document;
                self.imgdocumentation = data.imgdocumentation;
                self.companydetail = data.companydetail;
                self.is_receive = data.document.Status_Pekerjaan == "Menerima";
                self.is_not_receive = data.document.Status_Pekerjaan == "Tidak Bisa Menerima";

                self.dataDocument.Inspections.forEach((a,i) => {
                    self.arrindex.push( (i + 2) * 3 + 4)
                });
                self.arrindex.push(6)

                self.dataDocument.Participants.forEach((b,i)=>{
                    self.arrindex1.push(i + 1)
                });
                self.$emit('unblock-ui');
            
            }).catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 6000 });
                    self.$emit('unblock-ui');
            });
        },
    },
    computed:{
    },   
    created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;
            this.getData();
        },
}


    // window.onbeforeprint = function() {
    //     var table = document.getElementById('apps');
    //     var scrollHeight = table.scrollHeight;
    //     var totalPages = Math.round(scrollHeight / window.innerHeight);
    //     for (var i = 0; i < totalPages; i++) {
    //         document.querySelectorAll('.page-number')[i].textContent = 'Page ' + (i + 1) + ' of ' + totalPages;
    //     }
    // }
</script>
<style>
@page {
    size: A4 portrait;
    margin: 10mm;
}

@media print {
    #app .layout-wrapper .p-blockui-container .layout-topbar{
        display: none;
    }

    #app .layout-wrapper .p-blockui-container .layout-sidebar{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-footer{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-main-container{
        padding: 10px;
        margin: 0;
     }
    
}
@media screen and (max-width: 64em) {
    .p-sidebar-left.p-sidebar-lg,
    .p-sidebar-left.p-sidebar-md,
    .p-sidebar-right.p-sidebar-lg,
    .p-sidebar-right.p-sidebar-md {
        width: 20rem;
    }
}
#apps{
    width: 80%;
}

</style>
<style scoped>
@media print {
    tfoot {
      position: fixed;
      bottom: 0;
      width: 100%;
    }
    .tdfoot{
        width: 100%;
    }
    #toolbar{
        display: none;
    }
    #display{
        display: none;
    }

    body{
      width: 100%;
      margin: 0 auto;
    }

    #apps{
        width: 100%;
        margin-top: -5px;
    }


}

.table {
    border-collapse: collapse;
    width: 100%;
    color: black;
}
.table .th {
    padding-top: 12px;
    padding-bottom: 12px;
}
  /* #f9f340*/
.table .center{
    text-align: center;
}
.table td, .table th {
    border: 1px solid black;
}

.disabled{
    pointer-events: none;
}
.ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 12px;
    margin-top:-10px;
}

hr{
    border-top:2px solid black;
}

#toolbar{
    max-height: 90px;
}

.title{
    font-size: 20px;
}
.year{
    margin-left: 290px;
}
.center{
    margin: auto;
}
.p1 {
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
    white-space: normal;
    font-size:14px;
  }
  .widht1{
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
  }
  .fontsign{
    font-family: 'Monotype Corsiva'
  }
  .pagebreak{
        page-break-before: always;
    }
  .backgorund{
    background-color: rgb(200, 200, 200);
    /*background-color: rgb(238, 224, 178);*/
  }
  
</style>
